import React from 'react';
import HockeyGallery from './HockeyGallery';

export default function WharfGallery() {
  return (
    <HockeyGallery
      collection="wharf"
      title="🏒 District Wharf Hockey Tournament"
      subtitle="Washington DC · Photos & Stickers"
      accentColor="#4A7FA5"
      darkBg="#0f1923"
    />
  );
}
